import { apiSlice } from "../../app/api/apiSlice";

export const updateUploadXmlStatusApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		uploadXmlHistoryStatus: builder.mutation({
			query: (credentials) => ({
				url: "/api/v1/loan/update_pending_applications/",
				method: "POST",
				body: credentials?.formData,
			}),
		}),
	}),
});

export const { useUpdateUploadXmlStatusMutation } = updateUploadXmlStatusApiSlice;
